import { DatePipe } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-subscribe-dialog',
  templateUrl: './subscribe-dialog.component.html',
  styleUrls: ['./subscribe-dialog.component.css']
})
export class SubscribeDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  title =''
  subtitle = ''
  pipe = new DatePipe('en-GB'); // Use your own locale
  
  ngOnInit(): void {
    if (this.data.reminder) {

      const date = new Date(this.data.date)
      const newDate = new Date(date.setMonth(date.getMonth() - 2))

      const myFormattedDate = this.pipe.transform(newDate, 'dd MMM yyyy');

      this.title = 'Thanks for signing up!'
      this.subtitle = 'Look out for an email from us around ' + myFormattedDate +', this is two months before the end of your initial term which is a good time to start looking for remortgage deals'
    } else {
      this.title = 'Email sent!'
      this.subtitle = 'Thanks for using The Mortgage Calculator, we\'ve sent a copy of these results to the email address you entered'
    }
  }

}
